import React from 'react'
import {
  FluidImage,
  Banner,
  BannerTextContainer,
  BannerText,
  BannerTitle,
  BannerDescription,
  BannerEyebrow,
  BannerImageContainer,
  BannerImage,
  BannerLinks,
  Button,
  Icon,
  P,
  ProgressiveImage,
  Link,
} from '@vp/swan'
import { trackGwsPromotionClick } from './WebsShutdownAnalytics'
import { redirect } from '../../common/helpers/urlsHelper'

async function redirectToGWS(url: string) {
  trackGwsPromotionClick()
  redirect(url)
}

interface GwsPromoProps {
  content?: any
  url?: string
}

const GwsPromo = ({ content, url }: GwsPromoProps) => {
  return (
    <Banner variant="full-width-image">
      <BannerTextContainer pt={6}>
        <BannerText>
          <BannerEyebrow>
            <ProgressiveImage placeholder={content.gwsPromo.features[2].mediaUrl} src={content.gwsPromo.features[2].mediaUrl}>
              {(image) => (
                <FluidImage style={{ maxWidth: '10em' }} src={image.src} width="180" height="31" alt={content.newDomainsHero.backgroundImage.media.fileName} />
              )}
            </ProgressiveImage>
          </BannerEyebrow>
          <BannerTitle style={{ fontSize: '30px' }}>{content.gwsPromo.features[0].title}</BannerTitle>
          <BannerDescription>
            <P>{content.gwsPromo.features[0].description}</P>
          </BannerDescription>
          <BannerLinks>
            <Button
              skin="secondary"
              render={(props) => (
                <Link
                  className={props.className}
                  onClick={() => {
                    redirectToGWS(url)
                  }}
                >
                  {props.children}
                </Link>
              )}
            >
              {content.gwsPromo.features[1].title}
              <Icon iconType="arrowRight" />
            </Button>
          </BannerLinks>
        </BannerText>
      </BannerTextContainer>
      <BannerImageContainer>
        <BannerImage>
          <FluidImage
            srcSet={content.gwsPromo.features[0].mediaUrl}
            style={{
              objectPosition: '80%',
            }}
          />
        </BannerImage>
      </BannerImageContainer>
    </Banner>
  )
}

export default GwsPromo
